import { colors } from '@vst/beam';

import { hexToRgb } from '@app/utils';

const teal300RGB = `rgb(${hexToRgb(colors.teal[300])})`;
const teal600RGB = `rgb(${hexToRgb(colors.teal[600])})`;

export const barHighlightColorBuyMore = `repeating-linear-gradient(135deg, ${teal300RGB}, ${teal300RGB} 3px, ${teal600RGB} 1px, ${teal600RGB} 9px)`;
